import { render, staticRenderFns } from "./SwiftNameForm.vue?vue&type=template&id=04b8d816&scoped=true"
import script from "./SwiftNameForm.vue?vue&type=script&lang=js"
export * from "./SwiftNameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8d816",
  null
  
)

export default component.exports